import React from 'react';
import { FaLinkedin, FaYoutube, FaGithub, FaBookOpen, FaGraduationCap } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';
import './Hero.css';

const Hero = () => {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const socialLinks = [
    {
      name: 'LinkedIn',
      url: 'http://www.linkedin.com/in/sasan-mansouri-de',
      icon: FaLinkedin,
      color: '#0077B5'
    },
    {
      name: 'Google Scholar',
      url: 'https://scholar.google.de/citations?user=jgW3WbcAAAAJ&hl=en',
      icon: FaGraduationCap,
      color: '#4285F4'
    },
    {
      name: 'YouTube',
      url: 'https://www.youtube.com/channel/UCIO3PGvdSmYWnXPBLDvqZ_w/featured',
      icon: FaYoutube,
      color: '#FF0000'
    },
    {
      name: 'GitHub',
      url: 'http://github.com/sasi2400',
      icon: FaGithub,
      color: '#333'
    },
    {
      name: 'Goodreads',
      url: 'https://www.goodreads.com/user/show/31156150-sasan-mansoori',
      icon: FaBookOpen,
      color: '#553B08'
    }
  ];

  return (
    <section id="hero" className="hero" ref={ref}>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <div className={`hero-intro ${inView ? 'fade-in' : ''}`}>
              <h1>Dr. Sasan Mansouri</h1>
              <p className="hero-subtitle">Associate Professor of Digitalization & AI</p>
              <p className="hero-institution">Faculty of Economics and Business</p>
              <p className="hero-institution">University of Groningen</p>
              
              <div className="hero-description">
                <p>
                  I specialize in financial data science, information intermediaries, 
                  entrepreneurial finance, and sustainability. My research utilizes 
                  machine learning techniques, particularly natural language processing, 
                  to investigate information transmission dynamics in financial markets.
                </p>
              </div>

              <div className="hero-actions">
                <a href="/assets/CV/Resume.pdf" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Download CV
                </a>
              </div>
            </div>

            <div className={`hero-social ${inView ? 'slide-in-left' : ''}`}>
              <div className="social-links">
                {socialLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    style={{ '--hover-color': link.color }}
                    aria-label={link.name}
                  >
                    <link.icon />
                  </a>
                ))}
              </div>
            </div>
          </div>

          <div className={`hero-image ${inView ? 'slide-in-right' : ''}`}>
            <div className="image-container">
              <img src="/assets/img/sasan-mansouri.jpg" alt="Dr. Sasan Mansouri" />
              <div className="image-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 